mutation CreateCheckoutSession($tier: String!, $returnOrigin: String) {
  checkout: StreamToolsCreateCheckoutSession(tier: $tier, returnOrigin: $returnOrigin) {
    url
  }
}
